import { fileToBase64 } from 'utils/file'
import { getEmails } from '../helpers'

import { LogMailType } from './constants'
import type { FileData, LogEmailInfo } from './LogEmailComposser'
import type { SendEmailInfo } from './SendEmailComposser'
import type { RecipientsEmailType } from './components'
import type { DeleteAttachmentsPayload } from 'services/lead-email'

export const duplicateEmailValidation = (crrentEmail: string[], newEmail: string): boolean => {
  if (crrentEmail?.includes(newEmail)) {
    return true
  } else {
    return false
  }
}

export const convertFiles = async (files: File[]) => {
  const filePromises = files.map((file) => fileToBase64(file))
  return Promise.all(filePromises)
}

export const getTotalRecipients = ({
  addresses,
  readOnlyAddresses,
}: {
  addresses: SendEmailInfo['addresses']
  readOnlyAddresses: SendEmailInfo['readOnlyAddresses']
}): string[] => {
  const allAddresses = {
    recipients: [...getEmails(addresses?.recipients), ...getEmails(readOnlyAddresses?.recipients)],
    cc: [...getEmails(addresses?.cc), ...getEmails(readOnlyAddresses?.cc)],
    bcc: [...getEmails(addresses?.bcc), ...getEmails(readOnlyAddresses?.bcc)],
  }

  const allRecipientsEmail: string[] = []
  Object.values(allAddresses)?.map((emails) => {
    allRecipientsEmail.push(...emails)
  })

  return allRecipientsEmail
}

export const isOutgoing = (logEmailValues: LogEmailInfo) =>
  logEmailValues?.type?.label?.toLowerCase() == LogMailType?.outgoing ? true : false

export const emptyRecipient = { leadContact: [], usersList: [], newEmails: [] }

export const syntheticNameGenerator = (email: RecipientsEmailType): RecipientsEmailType => ({
  ...email,
  fullName: !email?.fullName ? email.value.split('@')[0] : email?.fullName,
})

export const emailSignatureWrapper = (signature?: string) =>
  signature ? `<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n${signature}` : ''

export const emailSignatureWrapperAppend = (currentBody: string, signature?: string) =>
  signature ? `${currentBody}<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n${signature}` : currentBody

export const getMappedEmailAttachments = ({
  attachments,
}: {
  attachments: FileData[]
}): DeleteAttachmentsPayload['attachments'] =>
  attachments
    ?.filter((i) => i.attachment_id !== undefined)
    .map((i) => ({
      file_name: i.file_name,
      attachment_id: i.attachment_id as string,
    }))
